/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import type {
    ConsentResponsev2DTO,
    GetRequestUserEmailConsentParams,
    HTTPValidationErrorDTO,
    MessageResponseDTO,
    SetEmailConsentDTO,
} from '../../model'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Set Email Consent
 */
export const postRequestUserEmailConsent = (
    setEmailConsentDTO: BodyType<SetEmailConsentDTO>,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<MessageResponseDTO>(
        {
            url: `/user/email_consent`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: setEmailConsentDTO,
            signal,
        },
        options,
    )
}

export const getPostRequestUserEmailConsentMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestUserEmailConsent>>,
        TError,
        { data: BodyType<SetEmailConsentDTO> },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestUserEmailConsent>>,
    TError,
    { data: BodyType<SetEmailConsentDTO> },
    TContext
> => {
    const mutationKey = ['postRequestUserEmailConsent']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation &&
          'mutationKey' in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestUserEmailConsent>>,
        { data: BodyType<SetEmailConsentDTO> }
    > = (props) => {
        const { data } = props ?? {}

        return postRequestUserEmailConsent(data, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestUserEmailConsentMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestUserEmailConsent>>
>
export type PostRequestUserEmailConsentMutationBody =
    BodyType<SetEmailConsentDTO>
export type PostRequestUserEmailConsentMutationError =
    ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Set Email Consent
 */
export const usePostRequestUserEmailConsent = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestUserEmailConsent>>,
            TError,
            { data: BodyType<SetEmailConsentDTO> },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestUserEmailConsent>>,
    TError,
    { data: BodyType<SetEmailConsentDTO> },
    TContext
> => {
    const mutationOptions =
        getPostRequestUserEmailConsentMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * @summary Get Email Consent
 */
export const getRequestUserEmailConsent = (
    params: GetRequestUserEmailConsentParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<ConsentResponsev2DTO>(
        { url: `/user/email_consent`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestUserEmailConsentQueryKey = (
    params?: GetRequestUserEmailConsentParams,
) => {
    return [`/user/email_consent`, ...(params ? [params] : [])] as const
}

export const getGetRequestUserEmailConsentQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserEmailConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestUserEmailConsentQueryKey(params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestUserEmailConsent>>
    > = ({ signal }) =>
        getRequestUserEmailConsent(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestUserEmailConsentQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestUserEmailConsent>>
>
export type GetRequestUserEmailConsentQueryError =
    ErrorType<HTTPValidationErrorDTO>

export function useGetRequestUserEmailConsent<
    TData = Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserEmailConsentParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestUserEmailConsent>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestUserEmailConsent<
    TData = Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserEmailConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestUserEmailConsent>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
export function useGetRequestUserEmailConsent<
    TData = Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserEmailConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary Get Email Consent
 */

export function useGetRequestUserEmailConsent<
    TData = Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestUserEmailConsentParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestUserEmailConsent>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
} {
    const queryOptions = getGetRequestUserEmailConsentQueryOptions(
        params,
        options,
    )

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
